<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">

            <v-overlay v-model="overlay"
                :color= "storeBusiness.themecolor!=NULL?storeBusiness.themecolor:'#FE5800'" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <!-- <v-card-title class="pa-0">



                <v-container style="min-height:200px;" class="topbg">
                    <v-row>
                        <v-col
                        cols="12"
                        md="12"
                        color="white--text"
                        class="text-center mt-5 mb-5"
                        style="color:#fff;"
                        >
                        Welcome to Juzzap
                        <br />
                        <span class style="font-size:16px;">A NEW PARADIGM</span>
                        </v-col>
                    </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>


            </v-card-title> -->

            <v-card-text class="d-flex d-md-none">
                <v-row align="start" justify="center">
                    <v-col cols="12" sm="12" md="12" class="pa-0">

                        <v-card-title>
                                Drink List
                                <div class="flex-grow-1"></div>

                                    <v-btn color="primary" class="ml-3" @click="createdrinkitem">Create Food Item</v-btn>
                            </v-card-title>


                    </v-col>
                </v-row>

                <!-- <v-row >
                  <v-col cols="12" md="12">
                      <v-card v-for="(drinkitem, index) in drinkitems" :key="index" class="pa-3 mb-3">
                        <v-row>
                          <v-col cols="2" md="2">
                            <v-avatar>
                                <img :src="drinkitem.image" />
                            </v-avatar>
                          </v-col>
                          <v-col cols="8" md="8">
                            <div>{{drinkitem.name}}</div>
                            <div>{{drinkitem.subtitle}}</div>


                          </v-col>
                          <v-col cols="2" md="2">
                            <v-btn @click="editdrinkItem(drinkitem.id)" color="primary " fab x-small dark
                            class="mt-2 mb-2">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn @click="deleteItem(drinkitem.id)" color="primary " fab x-small dark class="">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                  </v-col>
                </v-row> -->

            </v-card-text>



            <v-card-text class="d-none d-md-flex " justify="right">

              <v-row >

                  <v-col cols="6" class="text-left">
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="text-left">

                    <v-btn color="primary" class="ml-3 " @click="createdrinkitem">Create Drink Item</v-btn>
                    <v-btn color="primary" class="bounce ml-3" v-if="isdragged" @click="savemenu" >{{$t('zz_save_drink_menu_changes')}}</v-btn>
                    <!--<span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">{{savemsg}}</span> -->
                  </v-col>
                  <v-col cols="3" sm="3" md="3" align="right" class="stickybutton">
                    <v-btn v-if="selected.length>0" text tile  x-large raised  @click="deleteselecteditem()" color="primary" class="">
                      <span >Delete</span>
                    </v-btn>
                  </v-col>
              </v-row>

            </v-card-text>

            <v-card-text>
                <v-divider></v-divider>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="drinkitems"
                    :items-per-page="20"
                    item-key="name"
                    :search="search"
                    class="elevation-1"
                    :item-class="itemRowBackground"
                    :single-select="singleSelect"
                    show-select
                    >

                    <template v-slot:top>
                      <v-switch
                        v-model="singleSelect"
                        label="Single select"
                        class="pa-3"
                      ></v-switch>
                    </template>

                    <template v-slot:item.image="{ item }">
                        <v-avatar
                        tile
                        class="">
                            <img :src="item.fimage" :alt="item.title" />

                        </v-avatar>

                    </template>

                    <template v-slot:item.name="{ item }">

                      <div>{{item.name}}</div>
                      <div>{{item.subtitle}}</div>



                    </template>

                    <template v-slot:item.type="{ item }">

                        <table>
                            <tr v-for="(itema,cindex) in item.dtypes" :key="'c-'+item.id+'-'+item.dtypes.typename">

                            <td v-if="itema.typename!=''" style="border:none;">{{itema.typename}}</td>
                            </tr>
                        </table>

                    </template>

                    <template v-slot:item.showtype="{ item }">
                        <table>
                            <tr v-for="(itema,cindex) in item.dtypes" :key="'c-'+item.id+'-'+cindex">
                                <td style="border:none;">
                                    <div v-if="itema.showitem==1 ">
                                        <v-switch  color="success" :input-value="shw" @click="updateshowitem(itema.drinkitemtypeid,0)"  :id="'showonitem-'+item.drinkitemtypeid"></v-switch>
                                    </div>
                                    <div v-else>
                                        <v-switch  color="" :input-value="nshw" @click="updateshowitem(itema.drinkitemtypeid,1)"  :id="'showonitem-'+item.drinkitemtypeid"></v-switch>

                                    </div>

                                </td>


                            </tr>
                        </table>

                    </template>

                    <template v-slot:item.measure="{ item }">



                          <table>
                            <tr v-for="(itema,cindex) in item.measures" :key="'c-'+item.id+'-'+item.measures.mname">

                            <td v-if="itema.mname!=''" style="border:none;">{{itema.mname}}</td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:item.price="{ item }">



                          <table>
                            <tr v-for="(itema,cindex) in item.measures" :key="'c-'+item.id+'-'+item.measures.mname">

                            <td v-if="itema.price!=''" style="border:none;">{{itema.price}}</td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  color="primary"
                                  icon
                                  v-bind="attrs"
                                  v-on="on">
                                  <v-icon>fa fa-cogs</v-icon>
                              </v-btn>
                            </template>

                            <v-list>
                            <v-list-item
                            >
                                <v-btn icon @click="editdrinkItem(item.id)" color="primary " fab x-small dark
                                    class="mt-2 mb-2">
                                    <v-icon>mdi-square-edit-outline</v-icon>
                                </v-btn>
                            </v-list-item>
                            <v-list-item>
                                <v-btn icon @click="deleteItem(item.id)" color="primary " fab x-small dark class="">
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                            </v-list-item>



                            </v-list>
                        </v-menu>
                    </template>


                </v-data-table>
            </v-card-text>

            <!--
            <v-card-text  class="" style="width:100%;overflow-x:scroll;">

              <draggable @start="dragitem=1;" @end="dragfooditem('i');" v-model="drinkitems">


                <transition-group>

                  <div  class="overflowcol" v-for="(drinkitem,index) in drinkitems" :key="'i-'+index" :class="dragitem?'move':''">

                    <v-card :class="drinkitem.fimage=='https://api.juzzap.com/storage/images/fooditem.png'?'cardlistnone':'cardlist' " class="mb-2">
                        <v-row>
                          <v-col cols="2" md="2">
                            <v-avatar tile class="" >
                              <img :src="drinkitem.fimage" />
                            </v-avatar>
                          </v-col>

                          <v-col cols="4" md="4">

                            <div>{{drinkitem.name}}</div>
                            <div>{{drinkitem.subtitle}}</div>

                          </v-col>

                          <v-col cols="4" md="4">
                            <div>
                              <v-row v-if="drinkitem.measures">
                                  <v-col cols="6" md="6">
                                    <div style="font-weight:bold;">Measure Name</div>

                                  </v-col>
                                  <v-col cols="6" md="6">
                                    <div style="font-weight:bold;">Price</div>

                                  </v-col>
                              </v-row>
                            </div>
                            <div v-for="drinkitemmeasures in drinkitem.measures" :key="'c-'+drinkitem.id">
                                <v-row>
                                  <v-col cols="6" md="6">
                                    <div>{{drinkitemmeasures.mname}}</div>

                                  </v-col>
                                  <v-col cols="6" md="6">
                                    <div>{{drinkitemmeasures.price}}</div>

                                  </v-col>
                                </v-row>
                            </div>
                          </v-col>

                          <v-col cols="2" md="2">
                            <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      color="primary"
                                      icon
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                  </v-btn>
                                </template>

                                <v-list>
                                <v-list-item
                                >
                                    <v-btn icon @click="editdrinkItem(drinkitem.id)" color="primary " fab x-small dark
                                        class="mt-2 mb-2">
                                        <v-icon>mdi-pencil</v-icon>Edit
                                    </v-btn>
                                </v-list-item>
                                <v-list-item>
                                    <v-btn icon @click="deleteItem(drinkitem.id)" color="primary " fab x-small dark class="">
                                        <v-icon>mdi-delete</v-icon>Delete
                                    </v-btn>
                                </v-list-item>



                                </v-list>
                            </v-menu>

                          </v-col>

                        </v-row>
                    </v-card>

                  </div>
                </transition-group>

              </draggable>
            </v-card-text>
                    -->
        </v-card>
    </v-container>
</template>
<script>

import Vue from 'vue'
import draggable from 'vuedraggable'

export default
{
    props: {
    source: String
  },
  data: function () {return {

    singleSelect: false,
    selected: [],
    shw:true,
    nshw:false,
    search:"",
    savemsg:'',
    isdragged:0,
    dragitem:0,
    drag:0,

    juzzapLogo: require("@/assets/logo-Copy.png"),
    overlay:false,
    id:'',
    items: [],
    itemimg:"",
    headers: [
            { text: this.$i18n.t('zz_actions'), value: "image", sortable: false },
            { text: this.$i18n.t('zz_name'), value: "name" },
            { text: this.$i18n.t('zz_brand'), value: "brand" },
            { text: this.$i18n.t('zz_measures'), value: "measure" },
            { text: this.$i18n.t('zz_price'), value: "price" },
            { text: this.$i18n.t('zz_type'), value: "type" },
            { text: "Show", value: "showtype" },
            { text: "Created", value: "created_at" },
            { text: "", value: "action", sortable: false }
        ],
    drinkitems: [],
    fooditems:{
        courses:[]
    },
    business:0,
  }},
  components:
  {
    draggable,
  },
  created()
    {
      this.storeBusiness=JSON.parse(localStorage.getItem('business'));

      this.id=this.storeBusiness.id;

      this.overlay=true;


       this.$http
      .get(this.$apidomain+"drinkitemlistnew/"+this.id)
      .then(res => {
          if(res.data.success==0)
          {
              this.$router.push({name:'businesslistnew'});
          }
       this.drinkitems = res.data.drinkitems;
       this.overlay=false;

      })
      .catch(err => {
        console.log(err.response);
      });

        // this.getBusiness();

        this.storeBusiness=JSON.parse(localStorage.getItem('business'));
    },

  methods:
    {

      deleteselecteditem()
      {
          if (confirm("Are you sure you want to delete this drink item?"))
          {
            this.$http
            .post(this.$apidomain+"drinkdeleteall",{ ids: this.selected })
            .then(res =>
            {

              // alert(res.data.retailids);
              if(res.data.success==1)
              {
                this.$router.go("/");
              }
            })
            .catch(err => {
              console.log(err.response);
            });
          }
      },

      toggleAll ()
      {

        if (this.selected.length) this.selected = []
        else this.selected = this.items.slice()
      },

      itemRowBackground: function (item)
      {
        // console.log('item '+item);
        // alert('method');
        // const rowClass = 'style-1';
        // return rowClass;

          //alert(item);
        //return  'style-1';
        if(item.separation > 0)
        {
          return  'style-1';
        }
        else
        {
          return  'style-2';

        }

      },
      // editdrinkItem(drinkitemid)
      // {
      //     this.$router.push({name:'editfooditem',params:{id:fooditemid,business_id:this.storeBusiness.id}});

      // },
      row_classes(item){
        console.log('is '+item.separation?'separator':'');
        return item.separation?'separator':'';
      },
      updateshowitem(drinkitemtypeid,showitem)
      {
         this.overlay=true;

        //  let showitem=showitem;
         //showitem= document.getElementById('showonitem-'+itemid).value;

        // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updatedrinkitemtypeshow/"+drinkitemtypeid,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {

                        this.$http
                      .get(this.$apidomain+"drinkitemlistnew/"+this.id)
                      .then(res => {
                          if(res.data.success==0)
                          {
                              this.$router.push({name:'businesslistnew'});
                          }
                      this.drinkitems = res.data.drinkitems;
                      this.overlay=false;

                      })
                      .catch(err => {
                        console.log(err.response);
                      });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

      },
      editdrinkItem(drinkitemid)
      {
          this.$router.push({name:'editbusinessdrinkitem',params:{id:drinkitemid,business_id:this.storeBusiness.id}});
          // this.$router.push({name:'DrinkComponent',params:{id:drinkitemid,business_id:this.storeBusiness.id,dtype:'edit'}})
      },
      // deletedrinkItem(drinkitemid)
      // {

      // },
      savemenu()
      {
        this.overlay=true;

        this.$http
          .post(this.$apidomain+"savebusinessdrinkmenu",{data:JSON.stringify(this.drinkitems),businessid:this.id})
          .then(res => {
              if(res.data.success==1)
              {
                       this.savemsg=res.data.msg;

                      // this.isdragged=0;
                      // this.savemsg=res.data.msg;
                      // this.items = res.data.items;
                      // this.$http
                      // .get(this.$apidomain+"getfooditems/"+this.id)
                      // .then(res => {
                      //     if(res.data.success==0)
                      //     {
                      //         //this.$router.push({name:'businesslistnew'});
                      //     }
                      // this.fooditems = res.data.fooditems;
                      //     this.overlay=false;


                      // })
                      // .catch(err => {
                      //     console.log(err.response);
                      //     this.overlay=false;

                      // });
                          this.overlay=false;

              }
              // this.fooditems = res.data.fooditems
              // this.overlay=false;


          })
          .catch(err => {
              console.log(err.response);
              this.overlay=false;

          });
      },
      dragfooditem(dtype)
      {
            this.isdragged=1;
            this.savemsg='';
          // if(dtype=='c')
          // {
          //   this.drag=0;
          // }

          if(dtype=='i')
          {
            this.dragitem=0;
          }

      } ,

      deleteItem(drinkitemid)
      {
            if (confirm("Are you sure you want to delete this Items?"))
            {

              this.$http
                .post(this.$apidomain+"deletedrinkitem/"+drinkitemid)
                .then(res => {
                    if(res.data.success==0)
                    {
                        this.$router.push({name:'businesslistnew'});
                    }
                    else if(res.data.success==1)
                    {
                        this.$http
                        .get(this.$apidomain+"drinkitemlistnew/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                this.$router.push({name:'businesslistnew'});
                            }
                        this.drinkitems = res.data.drinkitems;
                        this.overlay=false;

                        })
                        .catch(err => {
                          console.log(err.response);
                        });

                        this.$router.go('/');


                    }
                    this.drinkitems = res.data.drinkitems;
                })
                .catch(err => {
                  console.log(err.response);
                });


            }
      },
      createdrinkitem()
      {
        this.$router.push({name:'createbusinessdrinkitem',params:{id:this.storeBusiness.id}});
      },
    }
}
</script>
<style scoped>
.style-1 {
  background-color: rgb(215,215,44)
}
.style-2 {
  background-color: rgb(114,114,67)
}
.cardlistnone
{
  border: none !important;
  box-shadow: none !important;
}
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
.move
{
    cursor: nesw-resize;
}
.overflowcol{

    flex-shrink: 0;

}
</style>
